<template>
    <div class="invoice">
        <el-container>
            <el-main ref="main">
                <el-tabs  v-model="activeName" style="width: 100%">
                    <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
                        <div class="container">
                            <div class="titleBox">
                                <div>申请信息：</div>
                                <!--                                <div class="titleNum">编号：1234567</div>-->
                            </div>
                        </div>
                        <el-table
                                ref="dataTable"
                                :data="invoiceList"
                                highlight-current-row
                                size="mini"
                                height="100%"
                                border
                        >
                            <el-table-column
                                    prop="deptName"
                                    label="项目部"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="projectName"
                                    label="项目名称"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="subContractName"
                                    label="分项合同名称"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="subContractSerial"
                                    label="分项合同编码"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billHead"
                                    label="发票抬头"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="taxPayerCode"
                                    label="纳税人识别号"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billCode"
                                    label="发票代码"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billNumber"
                                    label="发票号码"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="amountWithoutTax"
                                    label="不含税金额"
                                    width="120px"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="tax"
                                    label="税额"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="taxRateShow"
                                    label="税率"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="amount"
                                    label="发票金额"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billUsageShow"
                                    label="发票用途"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billTypeShow"
                                    label="发票类型"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="billInvoiceTypeShow"
                                    label="发票种类"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="createUserName"
                                    label="提交人"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                            <el-table-column
                                    prop="createTime"
                                    label="提交时间"
                                    :show-overflow-tooltip="true"
                            ></el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <el-tab-pane label="审批流程" name="Tab2" style="overflow-y: auto">
                        <el-form
                                ref="approveRef"
                                :model="approveForm"
                                label-width="200px"
                                style="text-align: left;">
                            <el-form-item
                                    v-for="(item, index) in approveList"
                                    :key="index"
                                    :label="`${item.jobName}：`"
                                    required>
                                <el-input style="width: 70%;" v-model="item.approveUserName" clearable></el-input>
                                <el-button @click="selectApproveTarget(item)" type="primary">选择</el-button>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>

            </el-main>
            <el-footer class="container">
                <div class="btnMid">
                    <el-button type="primary" @click="submit()">提 交</el-button>
                    <el-button type="info" @click="reset()">取 消</el-button>
                </div>
            </el-footer>
        </el-container>


        <approve-dialog
                :visible="approveDialogVisible"
                @close="approveDialogClose"
                title="选择审批人员"
                v-bind="approveDialogOptions"
        ></approve-dialog>
    </div>
</template>

<script>
    import Consts from "@/utils/consts";
    import {
        getApproveListService,
    } from "@/services/sysSettingService";
    import ApproveDialog from "../../meeting/bill/ApproveDialog";
    import {
        inputBillApproveSubmitService,
    } from '@/services/invoiceServices'
    import {createApproveProcessService} from "@/services/engineering";
    export default {
        name: "income-approve",
        data(){
            return {
                invoiceList:[],
                idList:[],
                dataForm:{
                    pageIndex: 1,
                    pageSize: 10,
                },
                activeName: 'Tab1',
                editableTabs: [{
                    label: '基本信息',
                    name: 'Tab1'
                }, {
                    label: '审批流程',
                    name: 'Tab2'
                }],

                approveDialogVisible: false,
                approveDialogOptions: {
                    approveVO: {},
                }, // 审批流弹出框的配置
                approveForm: {
                    headOfDepart: {
                        // 部门负责人
                        id: null,
                        name: "",
                    },
                    leaderOfCompany: {
                        // 集团分管领导
                        id: null,
                        name: "",
                    },
                }, // 审批流程
                approveList: [], // 审批流列表
            }
        },
        components: {
            ApproveDialog,
        },
        methods:{
            onActive(menuCode) {
                this.invoiceList = this.tabRouteParam.invoiceList;
                this.invoiceList.map(item => {
                    this.idList.push(item.id)
                })
                console.log(this.tabRouteParam)
                this.initApproveList(); // 新建提报单，要先去获取一次审批流模板
            },
            /**
             * 获取审批流列表
             * */
            initApproveList() {
                let params = {
                    orgId: sessionStorage.getItem("orgId"),
                    type: "salesInput",
                };
                getApproveListService(params)
                    .then((res) => {
                        if (res.code == Consts.Code_OK) {
                            let list = res.data || [];
                            list.forEach((item) => {
                                item.approveUserId = null;
                                item.approveUserName = "";
                                item.deptId = null;
                                item.deptName = "";
                                item.sort = item.sortId;
                            });
                            list.sort((a, b) => {
                                return a.sortId - b.sortId;
                            }); // 按照sortId排序，从小到大
                            this.approveList = [...list];
                        } else if (res.code == Consts.Code_Err) {
                            this.$alert(res.msg, "提示");
                        } else {
                            this.$alert(Consts.Err_Msg, "提示");
                        }
                    })
                    .catch((error) => {
                        this.$message.error(Consts.Err_Msg);
                    });
            },
            submit(){
                let isApprove = this.approveList.findIndex(item => item.approveUserId == null || item.approveUserId == ''|| item.approveUserName == '')
                if(isApprove != -1){
                    this.$message.error('请选择审批流后，在提交数据！');
                    return
                }
                let params = {
                    idList:this.idList,
                    approveProcessCreateDtoList: this.approveList
                }
                this.submitApprove(params);
            },
            reset(){
                this.bus.$emit("tabClose", "incomeApprove");
                this.bus.$emit("navMenuChange", {
                    routeId: "incomeInvoice"
                });
            },
            /**
             * 提交申请
             * */
            submitApprove(params){
                inputBillApproveSubmitService(params).then( res => {
                    if(res.code == 10000000){
                        // this.$message.success(res.msg);
                        // this.reset();
                        this.createApprove(res.data);
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            //创建审批流
            createApprove(id){
            let params = {
              approveClass: 'INPUT_BILL_APPROVE',
              approveProcessDtoList: this.approveList,
              approveStatusEnum:'UNDERAPLLY',
              projectId: this.invoiceList[0].projectId,
              itemId: id,
              itemName: `${sessionStorage.getItem('name')}关于${this.invoiceList[0].subContractName}的进项发票申请`,
            }
            createApproveProcessService(params).then((res) => {
              if (res.code == Consts.Code_OK) {
                this.$message.success('申请提交成功');
                this.reset();
              } else if (res.code == Consts.Code_Err) {
                this.$alert(res.msg, "提示");
              } else {
                this.$alert(Consts.Err_Msg, "提示");
              }
            }).catch((error) => {
              this.$message.error(Consts.Err_Msg);
            });
          },
            selectApproveTarget(item) {
                // 选择对应的审批人
                this.approveDialogOptions = {
                    approveVO: item,
                };
                this.approveDialogVisible = true;
            },
            approveDialogClose(data) {
                console.log("审批流程,关闭", data);
                this.approveDialogVisible = false;
                if (data) {
                    // 选了人了
                    this.approveList.forEach((item) => {
                        if (item.jobId == data.jobId) {
                            item.approveUserId = data.id;
                            item.approveUserName = data.displayName || data.name;
                            item.deptId = data.deptId;
                            item.deptName = data.deptDisplayName;
                            // item.jobId = data.jobId;
                            // item.jobName = data.jobName;
                        }
                    });
                }
            },
            // tabbar切换
            handletabClick(tab, event){
                console.log(tab)
            },
            // 分页改变事件
            handleCurrentChange(page) {
                this.dataForm.pageIndex = page;
                this.getInvoiceList();
            },
            // 分页显示数量改变事件
            handleSizeChange(rows) {
                this.dataForm.pageIndex = 1;
                this.dataForm.pageSize = rows;
                this.getInvoiceList();
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";
    .invoice {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
        .container{
            width: 900px;
            margin-bottom: 50px;
        }
    }
    /deep/.el-textarea{
        width: 600px;
    }
    /deep/.el-tabs__header{
        padding-right: 0 !important;
        .el-tabs__nav-wrap{
            padding-left: 30px;
        }
    }
    .titleBox{
        display: flex;
        color: rgba(16, 16, 16, 100);
        font-size: 16px;
        text-align: left;
        font-family: SourceHanSansSC-regular;
        font-weight: 600;
        border-bottom: 1px solid rgba(187, 187, 187, 100);
        margin:30px 20px 0;
        padding-bottom: 10px;
        .titleNum{
            margin-left: 30px;
        }
    }
    .dataFormBox{
        margin:30px 20px;
    }
    .btnMid {
        width: 300px;
        margin: 0 auto;
        display: flex;
        justify-content: space-around;
    }
</style>
